import Alpine from "alpinejs"
import "./polyfills"
import Bugsnag from "@bugsnag/js"
import dataStore from "./dataStore"
import translation from "./translation"
import components from "./components"
import prefetchNextPage from "./preload"
import { TrackingManager } from "../../../../lib/common/js/services/tracking/trackingManager"
import { getOrderData } from "../../../../lib/common/js/getOrderData"
import { errorsManager } from "../../../../lib/common/js/services/errors/errorsManager"
import { bugsnagAdapter } from "../../../../lib/common/js/services/errors/bugsnagAdapter"
import { sentryAdapter } from "../../../../lib/common/js/services/errors/sentryAdapter"

if (
  !window.location.host.includes("localhost") &&
  !window.location.host.includes("host.docker.internal")
) {
  errorsManager.init({
    adapters: [
      bugsnagAdapter,
      sentryAdapter
    ]
  })
}

document.addEventListener("DOMContentLoaded", function () {
  let sid = localStorage.getItem("fraud_net_session_id") ?? generateRandomString()

  localStorage.setItem("fraud_net_session_id", sid)

  const fraudNetSettings = document.createElement("script")
  fraudNetSettings.type = "application/json"
  fraudNetSettings.setAttribute("fncls", "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99")
  fraudNetSettings.text = JSON.stringify({
    f: sid,
    s: pipelineConfig.brandCode + "_" + window.getPage(),
  })

  document.body.appendChild(fraudNetSettings)
  const fraudNetScript = document.createElement("script")
  fraudNetScript.src = "https://c.paypal.com/da/r/fb.js"
  document.body.appendChild(fraudNetScript)

  const body = document.querySelector("body")

  // Add a CSS class to trigger animation
  window.requestAnimationFrame(() => {
    body.classList.add("pipe-dom-content-loaded")
  })

  const svgs = document.querySelectorAll("svg[data-pipe-svg-animation]")

  svgs.forEach((svg) => {
    window.requestAnimationFrame(() => {
      svg.classList.add("pipe-svg-loaded")
    })
  })
})

window.Alpine = Alpine

components.forEach(({ name, data }) => {
  Alpine.data(name, data)
})

getOrderData(dataStore).then(async () => {
  Alpine.store("data", dataStore)
  Alpine.start()
  translation.onInit()
  prefetchNextPage()
})

window.getCookieValue = function (name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(";").shift()

  return null
}

function generateRandomString(length = 32) {
  return Array.from({ length }, () =>
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(
      Math.floor(Math.random() * 62),
    ),
  ).join("")
}

window.getPage = function () {
  return window.location.href
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter((segment) => segment)
    .pop()
}

// TrackPageView event
window.addEventListener("pageshow", () => {
  const trackingConfig = window.trackingConfig

  if (
    trackingConfig &&
    trackingConfig.enabledTrackingServices &&
    trackingConfig.enabledTrackingServices.length > 0
  ) {
    const isTranslationMode = new URLSearchParams(window.location.hash.substring(1)).get(
      "translation_token",
    )
    const store = window.Alpine.store("data")
    const storeData = (store && store.values) || {}
    const data = { segmentUserId: storeData.segmentUserId || "" }

    // Do not log page view if translation mode is active or no store data is available
    if (isTranslationMode) return

    const tracker = new TrackingManager(trackingConfig.enabledTrackingServices, pipelineConfig)
    const serviceSettings = trackingConfig.serviceSettings || {}
    const enabledServices = trackingConfig.enabledTrackingServices || {}
    const restrictedPageViewServices = Object.keys(serviceSettings).filter(
      (key) => serviceSettings[key].restrictPageViewEnabled === true,
    )
    const resetUserDataServices = Object.keys(serviceSettings).filter(
      (key) => serviceSettings[key].resetUserData === true,
    )

    // Reset user data
    if (resetUserDataServices.length > 0) {
      resetUserDataServices.forEach((service) => {
        tracker.resetUserData(service)
      })
    }

    if (restrictedPageViewServices.length > 0) {
      // If we got restricted services, we only track page view for services that are not restricted
      enabledServices.forEach((service) => {
        if (!restrictedPageViewServices.includes(service)) {
          // For segment track even though aint identified
          if (service === "segment") {
            tracker.trackPageView(service)
          }

          tracker.isUserIdentified(data).then((isIdentified) => {
            if (isIdentified) {
              tracker.trackPageView()
            }
          })
        }
      })
    } else {
      if (
        trackingConfig.enabledTrackingServices.length === 1 &&
        trackingConfig.enabledTrackingServices.includes("segment")
      ) {
        tracker.trackPageView()
      } else {
        // Track page view for all enabled services
        tracker.isUserIdentified(data).then((isIdentified) => {
          if (isIdentified) {
            tracker.trackPageView()
          }
        })
      }
    }
  }
})

// TrackClick event from store
window.addEventListener("pageshow", () => {
  const trackingConfig = window.trackingConfig
  const klaviyoTrackEventsList = sessionStorage.getItem("klaviyoTrackEventsList")

  if (klaviyoTrackEventsList && klaviyoTrackEventsList.length > 0) {
    if (
      trackingConfig &&
      trackingConfig.enabledTrackingServices &&
      trackingConfig.enabledTrackingServices.length > 0
    ) {
      const isTranslationMode = new URLSearchParams(window.location.hash.substring(1)).get(
        "translation_token",
      )

      if (isTranslationMode) return

      const tracker = new TrackingManager(trackingConfig.enabledTrackingServices, pipelineConfig)
      let events = JSON.parse(klaviyoTrackEventsList)

      // Itterate over all events and track them and remove them from sessionStorage 1 by 1
      while (events.length > 0) {
        const eventPayload = events.shift()
        tracker.trackSessionStorageClickEvent(eventPayload)
        sessionStorage.setItem("klaviyoTrackEventsList", JSON.stringify(events)) // Update sessionStorage
      }
    }
  }
})
